import { IEvent, IIncomeEventDiff, IResultEventDiff } from '../interfaces';

export function eventDiffComparatorUtil(event: IEvent): Array<IResultEventDiff> {
  const income: IIncomeEventDiff = JSON.parse(event.reasonJson);
  if (!income.Old) {
    return isNew(income.New);
  }

  return createDiff(event.reasonJson);
}

function isNew(obj: object): Array<IResultEventDiff> {
  const result: Array<IResultEventDiff> = [];
  const keys = Object.keys(obj);

  keys.forEach((key: string) => {
    const item: IResultEventDiff = {
      fieldName: key,
      oldValue: undefined,
      newValue: obj[key],
    };

    if (item.newValue) {
      result.push(item);
    }
  });

  return result;
}

function createDiff(resultString: string): Array<IResultEventDiff> {
  const result: Array<IResultEventDiff> = [];
  const data: IIncomeEventDiff = JSON.parse(resultString);

  const keys = new Set<string>([ ...Object.keys(data.Old), ...Object.keys(data.New) ]);

  keys.forEach((key: string) => {
    const item: IResultEventDiff = {
      fieldName: key,
      oldValue: data.Old[key] ? data.Old[key] : 'none',
      newValue: data.New[key] ? data.New[key] : 'none',
    };

    if (data.Old[key] !== data.New[key]) {
      result.push(item);
    }
  });

  return result;
}
